export const categories = [
  {
    slug: 'yingshi',
    name: '影视精品',
    description: '汇聚国产优质影视作品赏析与深度评论',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'wenxue',
    name: '文学佳作',
    description: '当代华语文学精选，原创小说与散文',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'yinyue',
    name: '音乐鉴赏',
    description: '华语乐坛精品创作与深度乐评',
    icon: 'ri-music-2-line',
  },
  {
    slug: 'keji',
    name: '科技创新',
    description: '中国科技前沿动态与创新成果展示',
    icon: 'ri-cpu-line',
  },
  {
    slug: 'shenghuo',
    name: '生活美学',
    description: '品质生活方式探寻与国潮美学分享',
    icon: 'ri-leaf-line',
  },
  {
    slug: 'lishi',
    name: '历史人文',
    description: '中华历史文化深度解读与人文探索',
    icon: 'ri-landscape-line',
  },
];